window.addEventListener('DOMContentLoaded', function () {
  var ms = new affixor('.nav-microsite',-60); ms.init();
  var nm = new affixor('.nav-magellan',-60); nm.init();
  var p = new affixor('header.primary'); p.init();
});

function affixor( selector, offset ) {
  this.selector = selector;
  this.scrolledClassName = 'scrolled';
  this.spacerClassName = 'affixor-spacer';
  this.bodyClassName = 'affixor-' + selector.replace('.','');
  this.offset = offset ? offset : 0; // add an offset to when the affix starts
}
affixor.prototype.init = function () {
  this.detect();
  this.spacer();
  var thus = this;
  window.addEventListener('scroll', function(e){ thus.scroll(e) }, false);  
  this.scroll();
}
affixor.prototype.detect = function () {
  this.element = document.querySelector(this.selector);
  if( !this.element ) return;
  let scroll = window.scrollY;
  let top = scroll+this.element.getBoundingClientRect().top;

  this.top = top;
  this.originalHeight = parseFloat(this.element.getBoundingClientRect().height);
}
affixor.prototype.spacer = function () {
  if( !this.element ) return;
  this.spacer = document.createElement('div');
  this.spacer.className = this.spacerClassName;
  this.spacer.style.height = '0px';
  this.element.parentNode.insertBefore( this.spacer, this.element );
}
affixor.prototype.scroll = function () {
  if( !this.element ) return;
  let scroll = window.scrollY;
  if( scroll > this.top+this.offset+this.originalHeight ) {
    if( this.element.classList.contains(this.scrolledClassName) === false ) {
      document.body.classList.add(this.bodyClassName);
      this.element.classList.add(this.scrolledClassName);
      this.spacer.style.height = this.originalHeight + 'px';
    }
  } else {
    document.body.classList.remove(this.bodyClassName);
    this.element.classList.remove(this.scrolledClassName);
    this.spacer.style.height = '0px';
  }
}


// WEBPACK FOOTER //
// ./theme/_base/js/nav-scroll.js